import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import existing translation files
import publicHomeTranslationsEs from '../locales/es/home.json';
import publicHomeTranslationsEn from '../locales/en/home.json';
import sidebarTranslationsEs from '../locales/es/sidebar.json';
import sidebarTranslationsEn from '../locales/en/sidebar.json';
import pwaTranslationsEs from '../locales/es/pwa.json';
import pwaTranslationsEn from '../locales/en/pwa.json';
import emergencyGuideTranslationsEs from '../locales/es/emergency-guide.json';
import emergencyGuideTranslationsEn from '../locales/en/emergency-guide.json';

// Import legal translation files
import disclaimerTranslationsEs from '../locales/es/disclaimer.json';
import disclaimerTranslationsEn from '../locales/en/disclaimer.json';
import privacyPolicyTranslationsEs from '../locales/es/privacy-policy.json';
import privacyPolicyTranslationsEn from '../locales/en/privacy-policy.json';
import termsOfServiceTranslationsEs from '../locales/es/terms-of-service.json';
import termsOfServiceTranslationsEn from '../locales/en/terms-of-service.json';
import cookiePolicyTranslationsEs from '../locales/es/cookie-policy.json';
import cookiePolicyTranslationsEn from '../locales/en/cookie-policy.json';

// Import auth translation files
import authTranslationsEs from '../locales/es/auth.json';
import authTranslationsEn from '../locales/en/auth.json';

// Import dashboard translation files
import dashboardTranslationsEs from '../locales/es/dashboard.json';
import dashboardTranslationsEn from '../locales/en/dashboard.json';

// Import vehicles translation files
import vehiclesTranslationsEs from '../locales/es/vehicles.json';
import vehiclesTranslationsEn from '../locales/en/vehicles.json';

// Import insurance translation files
import insuranceTranslationsEs from '../locales/es/insurance.json';
import insuranceTranslationsEn from '../locales/en/insurance.json';

// Import common translation files
import commonTranslationsEs from '../locales/es/common.json';
import commonTranslationsEn from '../locales/en/common.json';

// Import device test translation files
import deviceTestTranslationsEs from '../locales/es/device-test.json';
import deviceTestTranslationsEn from '../locales/en/device-test.json';
import deviceTestSeoTranslationsEs from '../locales/es/device-test-seo.json';
import deviceTestSeoTranslationsEn from '../locales/en/device-test-seo.json';

// Import FAQ translation files
import faqTranslationsEs from '../locales/es/faq.json';
import faqTranslationsEn from '../locales/en/faq.json';

// Import quick links translation files
import quickLinksTranslationsEs from '../locales/es/quick-links.json';
import quickLinksTranslationsEn from '../locales/en/quick-links.json';

// Import about translation files
import aboutTranslationsEs from '../locales/es/about.json';
import aboutTranslationsEn from '../locales/en/about.json';

// Import delete account translation files
import deleteAccountTranslationsEs from '../locales/es/delete-account.json';
import deleteAccountTranslationsEn from '../locales/en/delete-account.json';

// Import Chinese translation files
import publicHomeTranslationsZh from '../locales/zh/home.json';
import sidebarTranslationsZh from '../locales/zh/sidebar.json';
import pwaTranslationsZh from '../locales/zh/pwa.json';
import emergencyGuideTranslationsZh from '../locales/zh/emergency-guide.json';
import disclaimerTranslationsZh from '../locales/zh/disclaimer.json';
import privacyPolicyTranslationsZh from '../locales/zh/privacy-policy.json';
import termsOfServiceTranslationsZh from '../locales/zh/terms-of-service.json';
import cookiePolicyTranslationsZh from '../locales/zh/cookie-policy.json';
import authTranslationsZh from '../locales/zh/auth.json';
import dashboardTranslationsZh from '../locales/zh/dashboard.json';
import vehiclesTranslationsZh from '../locales/zh/vehicles.json';
import insuranceTranslationsZh from '../locales/zh/insurance.json';
import commonTranslationsZh from '../locales/zh/common.json';
import deviceTestTranslationsZh from '../locales/zh/device-test.json';
import deviceTestSeoTranslationsZh from '../locales/zh/device-test-seo.json';
import quickLinksTranslationsZh from '../locales/zh/quick-links.json';
import aboutTranslationsZh from '../locales/zh/about.json';
import deleteAccountTranslationsZh from '../locales/zh/delete-account.json';
import faqTranslationsZh from '../locales/zh/faq.json';

// Import Catalan translation files
import publicHomeTranslationsCa from '../locales/ca/home.json';
import sidebarTranslationsCa from '../locales/ca/sidebar.json';
import pwaTranslationsCa from '../locales/ca/pwa.json';
import emergencyGuideTranslationsCa from '../locales/ca/emergency-guide.json';
import disclaimerTranslationsCa from '../locales/ca/disclaimer.json';
import privacyPolicyTranslationsCa from '../locales/ca/privacy-policy.json';
import termsOfServiceTranslationsCa from '../locales/ca/terms-of-service.json';
import cookiePolicyTranslationsCa from '../locales/ca/cookie-policy.json';
import authTranslationsCa from '../locales/ca/auth.json';
import dashboardTranslationsCa from '../locales/ca/dashboard.json';
import vehiclesTranslationsCa from '../locales/ca/vehicles.json';
import insuranceTranslationsCa from '../locales/ca/insurance.json';
import commonTranslationsCa from '../locales/ca/common.json';
import deviceTestTranslationsCa from '../locales/ca/device-test.json';
import deviceTestSeoTranslationsCa from '../locales/ca/device-test-seo.json';
import quickLinksTranslationsCa from '../locales/ca/quick-links.json';
import aboutTranslationsCa from '../locales/ca/about.json';
import deleteAccountTranslationsCa from '../locales/ca/delete-account.json';
import faqTranslationsCa from '../locales/ca/faq.json';

// Import Moroccan Arabic translation files
import publicHomeTranslationsMa from '../locales/ma/home.json';
import sidebarTranslationsMa from '../locales/ma/sidebar.json';
import pwaTranslationsMa from '../locales/ma/pwa.json';
import emergencyGuideTranslationsMa from '../locales/ma/emergency-guide.json';
import disclaimerTranslationsMa from '../locales/ma/disclaimer.json';
import privacyPolicyTranslationsMa from '../locales/ma/privacy-policy.json';
import termsOfServiceTranslationsMa from '../locales/ma/terms-of-service.json';
import cookiePolicyTranslationsMa from '../locales/ma/cookie-policy.json';
import authTranslationsMa from '../locales/ma/auth.json';
import dashboardTranslationsMa from '../locales/ma/dashboard.json';
import vehiclesTranslationsMa from '../locales/ma/vehicles.json';
import insuranceTranslationsMa from '../locales/ma/insurance.json';
import commonTranslationsMa from '../locales/ma/common.json';
import deviceTestTranslationsMa from '../locales/ma/device-test.json';
import deviceTestSeoTranslationsMa from '../locales/ma/device-test-seo.json';
import quickLinksTranslationsMa from '../locales/ma/quick-links.json';
import aboutTranslationsMa from '../locales/ma/about.json';
import deleteAccountTranslationsMa from '../locales/ma/delete-account.json';
import faqTranslationsMa from '../locales/ma/faq.json';

// Import Portuguese translation files
import publicHomeTranslationsPt from '../locales/pt/home.json';
import sidebarTranslationsPt from '../locales/pt/sidebar.json';
import pwaTranslationsPt from '../locales/pt/pwa.json';
import emergencyGuideTranslationsPt from '../locales/pt/emergency-guide.json';
import disclaimerTranslationsPt from '../locales/pt/disclaimer.json';
import privacyPolicyTranslationsPt from '../locales/pt/privacy-policy.json';
import termsOfServiceTranslationsPt from '../locales/pt/terms-of-service.json';
import cookiePolicyTranslationsPt from '../locales/pt/cookie-policy.json';
import authTranslationsPt from '../locales/pt/auth.json';
import dashboardTranslationsPt from '../locales/pt/dashboard.json';
import vehiclesTranslationsPt from '../locales/pt/vehicles.json';
import insuranceTranslationsPt from '../locales/pt/insurance.json';
import commonTranslationsPt from '../locales/pt/common.json';
import deviceTestTranslationsPt from '../locales/pt/device-test.json';
import deviceTestSeoTranslationsPt from '../locales/pt/device-test-seo.json';
import quickLinksTranslationsPt from '../locales/pt/quick-links.json';
import aboutTranslationsPt from '../locales/pt/about.json';
import deleteAccountTranslationsPt from '../locales/pt/delete-account.json';
import faqTranslationsPt from '../locales/pt/faq.json';

// Import French translation files
import publicHomeTranslationsFr from '../locales/fr/home.json';
import sidebarTranslationsFr from '../locales/fr/sidebar.json';
import pwaTranslationsFr from '../locales/fr/pwa.json';
import emergencyGuideTranslationsFr from '../locales/fr/emergency-guide.json';
import disclaimerTranslationsFr from '../locales/fr/disclaimer.json';
import privacyPolicyTranslationsFr from '../locales/fr/privacy-policy.json';
import termsOfServiceTranslationsFr from '../locales/fr/terms-of-service.json';
import cookiePolicyTranslationsFr from '../locales/fr/cookie-policy.json';
import authTranslationsFr from '../locales/fr/auth.json';
import dashboardTranslationsFr from '../locales/fr/dashboard.json';
import vehiclesTranslationsFr from '../locales/fr/vehicles.json';
import insuranceTranslationsFr from '../locales/fr/insurance.json';
import commonTranslationsFr from '../locales/fr/common.json';
import deviceTestTranslationsFr from '../locales/fr/device-test.json';
import deviceTestSeoTranslationsFr from '../locales/fr/device-test-seo.json';
import quickLinksTranslationsFr from '../locales/fr/quick-links.json';
import aboutTranslationsFr from '../locales/fr/about.json';
import deleteAccountTranslationsFr from '../locales/fr/delete-account.json';
import faqTranslationsFr from '../locales/fr/faq.json';

// Import Romanian translation files
import publicHomeTranslationsRo from '../locales/ro/home.json';
import sidebarTranslationsRo from '../locales/ro/sidebar.json';
import pwaTranslationsRo from '../locales/ro/pwa.json';
import emergencyGuideTranslationsRo from '../locales/ro/emergency-guide.json';
import disclaimerTranslationsRo from '../locales/ro/disclaimer.json';
import privacyPolicyTranslationsRo from '../locales/ro/privacy-policy.json';
import termsOfServiceTranslationsRo from '../locales/ro/terms-of-service.json';
import cookiePolicyTranslationsRo from '../locales/ro/cookie-policy.json';
import authTranslationsRo from '../locales/ro/auth.json';
import dashboardTranslationsRo from '../locales/ro/dashboard.json';
import vehiclesTranslationsRo from '../locales/ro/vehicles.json';
import insuranceTranslationsRo from '../locales/ro/insurance.json';
import commonTranslationsRo from '../locales/ro/common.json';
import deviceTestTranslationsRo from '../locales/ro/device-test.json';
import deviceTestSeoTranslationsRo from '../locales/ro/device-test-seo.json';
import quickLinksTranslationsRo from '../locales/ro/quick-links.json';
import aboutTranslationsRo from '../locales/ro/about.json';
import deleteAccountTranslationsRo from '../locales/ro/delete-account.json';
import faqTranslationsRo from '../locales/ro/faq.json';

export const defaultNS = 'home';

export const resources = {
  es: {
    home: publicHomeTranslationsEs,
    sidebar: sidebarTranslationsEs,
    pwa: pwaTranslationsEs,
    'emergency-guide': emergencyGuideTranslationsEs,
    disclaimer: disclaimerTranslationsEs,
    'privacy-policy': privacyPolicyTranslationsEs,
    'terms-of-service': termsOfServiceTranslationsEs,
    'cookie-policy': cookiePolicyTranslationsEs,
    auth: authTranslationsEs,
    dashboard: dashboardTranslationsEs,
    vehicles: vehiclesTranslationsEs,
    insurance: insuranceTranslationsEs,
    common: commonTranslationsEs,
    'device-test': deviceTestTranslationsEs,
    'device-test-seo': deviceTestSeoTranslationsEs,
    'quick-links': quickLinksTranslationsEs,
    about: aboutTranslationsEs,
    'delete-account': deleteAccountTranslationsEs,
    faq: faqTranslationsEs,
  },
  en: {
    home: publicHomeTranslationsEn,
    sidebar: sidebarTranslationsEn,
    pwa: pwaTranslationsEn,
    'emergency-guide': emergencyGuideTranslationsEn,
    disclaimer: disclaimerTranslationsEn,
    'privacy-policy': privacyPolicyTranslationsEn,
    'terms-of-service': termsOfServiceTranslationsEn,
    'cookie-policy': cookiePolicyTranslationsEn,
    auth: authTranslationsEn,
    dashboard: dashboardTranslationsEn,
    vehicles: vehiclesTranslationsEn,
    insurance: insuranceTranslationsEn,
    common: commonTranslationsEn,
    'device-test': deviceTestTranslationsEn,
    'device-test-seo': deviceTestSeoTranslationsEn,
    'quick-links': quickLinksTranslationsEn,
    about: aboutTranslationsEn,
    'delete-account': deleteAccountTranslationsEn,
    faq: faqTranslationsEn,
  },
  zh: {
    home: publicHomeTranslationsZh,
    sidebar: sidebarTranslationsZh,
    pwa: pwaTranslationsZh,
    'emergency-guide': emergencyGuideTranslationsZh,
    disclaimer: disclaimerTranslationsZh,
    'privacy-policy': privacyPolicyTranslationsZh,
    'terms-of-service': termsOfServiceTranslationsZh,
    'cookie-policy': cookiePolicyTranslationsZh,
    auth: authTranslationsZh,
    dashboard: dashboardTranslationsZh,
    vehicles: vehiclesTranslationsZh,
    insurance: insuranceTranslationsZh,
    common: commonTranslationsZh,
    'device-test': deviceTestTranslationsZh,
    'device-test-seo': deviceTestSeoTranslationsZh,
    'quick-links': quickLinksTranslationsZh,
    about: aboutTranslationsZh,
    'delete-account': deleteAccountTranslationsZh,
    faq: faqTranslationsZh,
  },
  ca: {
    home: publicHomeTranslationsCa,
    sidebar: sidebarTranslationsCa,
    pwa: pwaTranslationsCa,
    'emergency-guide': emergencyGuideTranslationsCa,
    disclaimer: disclaimerTranslationsCa,
    'privacy-policy': privacyPolicyTranslationsCa,
    'terms-of-service': termsOfServiceTranslationsCa,
    'cookie-policy': cookiePolicyTranslationsCa,
    auth: authTranslationsCa,
    dashboard: dashboardTranslationsCa,
    vehicles: vehiclesTranslationsCa,
    insurance: insuranceTranslationsCa,
    common: commonTranslationsCa,
    'device-test': deviceTestTranslationsCa,
    'device-test-seo': deviceTestSeoTranslationsCa,
    'quick-links': quickLinksTranslationsCa,
    about: aboutTranslationsCa,
    'delete-account': deleteAccountTranslationsCa,
    faq: faqTranslationsCa,
  },
  ma: {
    home: publicHomeTranslationsMa,
    sidebar: sidebarTranslationsMa,
    pwa: pwaTranslationsMa,
    'emergency-guide': emergencyGuideTranslationsMa,
    disclaimer: disclaimerTranslationsMa,
    'privacy-policy': privacyPolicyTranslationsMa,
    'terms-of-service': termsOfServiceTranslationsMa,
    'cookie-policy': cookiePolicyTranslationsMa,
    auth: authTranslationsMa,
    dashboard: dashboardTranslationsMa,
    vehicles: vehiclesTranslationsMa,
    insurance: insuranceTranslationsMa,
    common: commonTranslationsMa,
    'device-test': deviceTestTranslationsMa,
    'device-test-seo': deviceTestSeoTranslationsMa,
    'quick-links': quickLinksTranslationsMa,
    about: aboutTranslationsMa,
    'delete-account': deleteAccountTranslationsMa,
    faq: faqTranslationsMa,
  },
  pt: {
    home: publicHomeTranslationsPt,
    sidebar: sidebarTranslationsPt,
    pwa: pwaTranslationsPt,
    'emergency-guide': emergencyGuideTranslationsPt,
    disclaimer: disclaimerTranslationsPt,
    'privacy-policy': privacyPolicyTranslationsPt,
    'terms-of-service': termsOfServiceTranslationsPt,
    'cookie-policy': cookiePolicyTranslationsPt,
    auth: authTranslationsPt,
    dashboard: dashboardTranslationsPt,
    vehicles: vehiclesTranslationsPt,
    insurance: insuranceTranslationsPt,
    common: commonTranslationsPt,
    'device-test': deviceTestTranslationsPt,
    'device-test-seo': deviceTestSeoTranslationsPt,
    'quick-links': quickLinksTranslationsPt,
    about: aboutTranslationsPt,
    'delete-account': deleteAccountTranslationsPt,
    faq: faqTranslationsPt,
  },
  fr: {
    home: publicHomeTranslationsFr,
    sidebar: sidebarTranslationsFr,
    pwa: pwaTranslationsFr,
    'emergency-guide': emergencyGuideTranslationsFr,
    disclaimer: disclaimerTranslationsFr,
    'privacy-policy': privacyPolicyTranslationsFr,
    'terms-of-service': termsOfServiceTranslationsFr,
    'cookie-policy': cookiePolicyTranslationsFr,
    auth: authTranslationsFr,
    dashboard: dashboardTranslationsFr,
    vehicles: vehiclesTranslationsFr,
    insurance: insuranceTranslationsFr,
    common: commonTranslationsFr,
    'device-test': deviceTestTranslationsFr,
    'device-test-seo': deviceTestSeoTranslationsFr,
    'quick-links': quickLinksTranslationsFr,
    about: aboutTranslationsFr,
    'delete-account': deleteAccountTranslationsFr,
    faq: faqTranslationsFr,
  },
  ro: {
    home: publicHomeTranslationsRo,
    sidebar: sidebarTranslationsRo,
    pwa: pwaTranslationsRo,
    'emergency-guide': emergencyGuideTranslationsRo,
    disclaimer: disclaimerTranslationsRo,
    'privacy-policy': privacyPolicyTranslationsRo,
    'terms-of-service': termsOfServiceTranslationsRo,
    'cookie-policy': cookiePolicyTranslationsRo,
    auth: authTranslationsRo,
    dashboard: dashboardTranslationsRo,
    vehicles: vehiclesTranslationsRo,
    insurance: insuranceTranslationsRo,
    common: commonTranslationsRo,
    'device-test': deviceTestTranslationsRo,
    'device-test-seo': deviceTestSeoTranslationsRo,
    'quick-links': quickLinksTranslationsRo,
    about: aboutTranslationsRo,
    'delete-account': deleteAccountTranslationsRo,
    faq: faqTranslationsRo,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Remove lng to let detector work
    fallbackLng: 'es',
    debug: import.meta.env.DEV,

    // Supported languages
    supportedLngs: ['es', 'en', 'zh', 'ca', 'ma', 'pt', 'fr', 'ro'],

    // Prevent fallback to similar languages
    nonExplicitSupportedLngs: false,

    // Load language with region for complex codes like ar-MA
    load: 'all',

    defaultNS,
    ns: [
      'home',
      'sidebar',
      'pwa',
      'emergency-guide',
      'disclaimer',
      'privacy-policy',
      'terms-of-service',
      'cookie-policy',
      'auth',
      'dashboard',
      'vehicles',
      'insurance',
      'common',
      'device-test',
      'device-test-seo',
      'quick-links',
      'about',
      'delete-account',
      'faq',
    ],
    resources,

    // Language detector options
    detection: {
      // Order of detection methods
      order: ['querystring', 'localStorage'],

      // Cache user language in localStorage
      caches: ['localStorage'],

      // Query string parameter name
      lookupQuerystring: 'lng',

      // localStorage key
      lookupLocalStorage: 'i18nextLng',

      // Exclude cache when detecting from navigator
      excludeCacheFor: ['cimode'],

      // Convert detected language and ensure only supported languages
      convertDetectedLanguage: (lng: string) => {
        const supportedLanguages = [
          'es',
          'en',
          'zh',
          'ca',
          'ma',
          'pt',
          'fr',
          'ro',
        ];

        // Normalize the language code
        const normalizedLng = lng.toLowerCase().trim();

        // Handle Arabic variants - map any Arabic variant to ma
        if (normalizedLng.startsWith('ar')) {
          return 'ma';
        }

        // Extract base language code
        const baseLng = normalizedLng.split('-')[0];

        // Return exact match for supported languages or fallback to Spanish
        if (supportedLanguages.includes(baseLng)) {
          return baseLng;
        }

        // Default fallback
        return 'es';
      },
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
